module.exports = __webpack_public_path__ + "img/img_index_banner_xhuan@2x.587bbcaf.png";